export const ACCEPT_FILE = 'image/png, image/jpg, image/jpeg'
